import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "icon"];
import SVGTextIconStyle from './SVGTextIconStyle';
import SVGWrapper from './SVGWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
const SVGIcon = props => {
  const {
      size,
      icon
    } = props,
    innerProps = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(SVGWrapper, {
    size: size,
    "data-test-id": "avatar-svg-icon",
    children: /*#__PURE__*/_jsx(SVGTextIconStyle, Object.assign({}, innerProps, {
      children: icon
    }))
  });
};
export default SVGIcon;